"use strict";

exports.__esModule = true;
exports.DsFileTypeIcon = void 0;
require("./DsFileTypeIcon.css");
var _jsxRuntime = require("react/jsx-runtime");
var DsFileTypeIcon = exports.DsFileTypeIcon = function DsFileTypeIcon(_ref) {
  var iconCode = _ref.iconCode,
    title = _ref.title,
    size = _ref.size,
    _float = _ref["float"];
  var getIconStyle = function getIconStyle(size) {
    return {
      width: size,
      height: size,
      backgroundSize: 'cover'
    };
  };
  var icon = "type--" + iconCode;
  var floating = "" + (_float ? "float-" + _float : '');
  var style = size === 'small' ? getIconStyle('1.7rem') : getIconStyle('2.5rem');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: style,
    title: title,
    className: icon + " " + floating
  });
};